import { size } from "polished";
import styled from "styled-components";
import ArrowLeft from "../../../img/icons/transfer-arrow-left.svg?react";
import ArrowRight from "../../../img/icons/transfer-arrow-right.svg?react";
import { ElementTable } from "../../ElementTable";

export const TransfersPanelHeading = styled.h3`
  margin: 0;
  padding: ${({ theme }) => `${theme.space[2]} 0`};
  font-size: ${({ theme }) => theme.fontSizes[5]};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    font-size: ${({ theme }) => theme.fontSizes[5]};
  }
`;

export const BodyArrowIn = styled(ArrowRight)`
  ${size(12)};
  path {
    fill: #2fab2f;
  }
  [dir="rtl"] & {
    transform: scaleX(-1);
  }
`;

export const BodyArrowOut = styled(ArrowLeft)`
  ${size(12)};
  path {
    fill: #de0f0f;
  }
  [dir="rtl"] & {
    transform: scaleX(-1);
  }
`;

export const TransfersTable = styled(ElementTable)`
  th:not(:nth-child(4)) {
    text-align: center;
  }
`;

export const StatusCol = styled.th`
  width: 12%;
`;

export const ArrowCol = styled.th`
  width: 10%;
`;

export const PosCol = styled.th`
  width: 14%;
  text-align: center;
`;

export const ClubCol = styled.th`
  width: 16%;
`;

export const PlayerCol = styled.th`
  width: 32%;
`;

export const TransfersCol = styled.th`
  width: 16%;
`;
